<ion-header class="ion-no-border">
  <ion-toolbar mode="md">
    <ion-buttons slot="start">
      <ion-button
        (click)="cancel()"
        aria-label="Cancelar"
      >
        <ion-icon
          slot="icon-only"
          src="../assets/material-symbols/close_24dp.svg"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <!-- <ion-title>{{ 'market.confirm_accept' | translate }}</ion-title> -->
    <ion-title>Interesado en carga {{ freight.reference }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <lib-freight-available-detail-modal-data [freight]="freight"></lib-freight-available-detail-modal-data>

  <!-- TODO translate this -->
  <p><strong>Resumen de los términos y condiciones</strong></p>
  <div class="fs-sm">
    <p>Al pulsar en el botón de "Estoy interesado" de esta carga:</p>
    <ul>
      <li>Nos indicas que estás interesado en esta carga o en una de características similares</li>
      <li>Nuestro departamento de tráfico contactará contigo para confirmar los detalles;</li>
      <li>Si ambas partes aceptan las condiciones, entonces se formalizará el contrato de transporte.</li>
    </ul>
    <p>
      Por tanto,
      <strong
        >la solicitud constituye únicamente una manifestación de interés y no implica la celebración de un contrato de
        transporte</strong
      >.
    </p>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-grid class="ion-padding-vertical-0">
      <ion-row>
        <ion-col>
          <ion-button
            (click)="confirm()"
            color="primary"
            expand="block"
            size="large"
            fill="solid"
          >
            <ion-icon
              slot="start"
              aria-hidden="true"
              src="../assets/material-symbols/check_24dp.svg"
            ></ion-icon>
            <!-- {{ 'general.confirm' | translate }} -->
            Estoy interesado
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
